import * as React from "react"
import { Container, Modal, Row, Col, Button, Form } from "react-bootstrap"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import { APIError } from "../../api/ObservableFromFetch"
import EventExcuseObservable, { CanSubstituteOnExcuseObservable } from "../../api/Randoms/EventExcuse"
import SelectionInboxGridRow from "../../api/Randoms/SelectionInboxModel/SelectionInboxGridRow"
import ConfirmationModal from "../ConfirmationModal"
import ActionButton from "../ActionButton"
import { IsOnTrack } from "../../App"

import ExcuseReason, { AlternateExcuseReasons, IsAltOtherExcuseReason } from "../../api/Randoms/RandomsModel/ExcuseReason"

interface ExcuseEventModalProps {
  show: boolean
  excuseDetails?: SelectionInboxGridRow
  onClose: (success: boolean) => void
}

interface ExcuseEventModalState {
  comment: string
  canExcuse: boolean
  saving: boolean
  loading: boolean
  excuseMode: number
  excuseReasonCode: string
  excuseComment: string
}
const ExcuseOnly: number = 1
const ExcuseAndAltrnate: number = 2

export default class ExcuseEventModal extends React.PureComponent<ExcuseEventModalProps, {}> {
  state: ExcuseEventModalState = {
    comment: "",
    canExcuse: false,
    saving: false,
    loading: false,
    excuseMode: 0,
    excuseReasonCode: "",
    excuseComment: ""
  }
  excuseSubscription?: Subscription
  canExcuseSubscription?: Subscription

  componentDidMount() {
    const isOnTrack = IsOnTrack()
    if (isOnTrack) {
      return;
    }
    this.setState({ canExcuse: false, loading: true })
    this.canExcuseSubscription && this.canExcuseSubscription.unsubscribe()
    this.canExcuseSubscription = CanSubstituteOnExcuseObservable(this.props.excuseDetails!.TestDetailID).subscribe(
      (result: boolean) => {
        this.setState({
          canExcuse: result,
          loading: false
        })
      },

      error => this.handleAPIError(error, { canExcuse: false, loading: false })
    )

  }

  componentWillUnmount() {
    this.excuseSubscription && this.excuseSubscription.unsubscribe()
    this.canExcuseSubscription && this.canExcuseSubscription.unsubscribe()
  }

  excuse = (generateReplacement: boolean) => {
    this.setState({ saving: true })
    const excuseReasonCode: string = this.state.excuseReasonCode || ""
    const excuseComment: string = this.state.excuseComment || ""
    this.excuseSubscription && this.excuseSubscription.unsubscribe()
    this.excuseSubscription = EventExcuseObservable(this.props.excuseDetails!.TestEventID, this.props.excuseDetails!.TestDetailID, generateReplacement, this.state.comment.trim(), excuseReasonCode, excuseComment).subscribe(
      result => {
        toast.success(result)
        this.props.onClose(true)
      },
      error => this.handleAPIError(error, { saving: false })
    )
  }
  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }
  toggleAlternateExcuseOption = (excuseMode: number) => {
    this.setState({ excuseMode: excuseMode })
  }
  onAltReasonChange = (value: string) => {
    this.setState({ excuseReasonCode: value })
  }

  isAltOtherReasonSelectd = () => {
    return IsAltOtherExcuseReason(this.state.excuseReasonCode)
  }
  render() {
    const { excuseDetails, show } = this.props
    const isOnTrack = IsOnTrack()

    const { canExcuse, saving, loading, excuseMode } = this.state
    const disableExcuse = (isOnTrack && (this.state.comment.trim().length === 0)) || loading || saving
    const disableAltrnate = isOnTrack || loading || saving || (this.isAltOtherReasonSelectd() && this.state.excuseComment.trim().length == 0)
    const disableExcuseButton = disableExcuse || (!isOnTrack && excuseMode !== ExcuseOnly) || (this.isAltOtherReasonSelectd() && this.state.excuseComment.trim().length == 0)
    const disableExcuseAnAlternateButton = disableExcuse || !canExcuse || (!isOnTrack && excuseMode !== ExcuseAndAltrnate) || disableAltrnate
    if (isOnTrack) {
      return <ConfirmationModal show={this.props.show}
        title="EXCUSE EVENTS"
        confirmButtonText="VERIFY"
        onConfirm={() => this.excuse(false)}
        onHide={() => this.props.onClose(false)}
        size="lg"
        disableConfirmButton={disableExcuseButton}
        spinConfirmButton={this.state.saving}
        disableConfirmOnSpin={true}>
        <Form>
          <Form.Row className="form-group">
            <Col>You have selected to excuse {excuseDetails?.FirstName} {excuseDetails?.LastName} from taking a pending {excuseDetails?.Service}. Doing so will remove this event from being tested for the associated pool and will affect the minimum required events to be completed for this selection period.  You are required to provide reason for excusal.</Col>
          </Form.Row>
          <Form.Row className="form-group required">
            <Form.Label column lg={3} htmlFor="comment">Reason for excusing</Form.Label>
            <Col lg={9}>
              <Form.Control
                id="comment"
                as="textarea"
                rows={3}
                value={this.state.comment}
                onChange={e => this.setState({ comment: e.target.value })} />
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>Clicking Verify will mark the scheduling event status as “Excused”, will add the comments to the scheduling notes and will remove the event from the Random Selection Inbox grid.  Excused events can be filtered from the Results grid.</Col>
          </Form.Row>
        </Form>
      </ConfirmationModal>
    }
    const donorName = excuseDetails?.DonorName || ""
    const title = "EXCUSE EVENTS"
    const size = "xl"
    const exceuseButtonText = "EXCUSE"
    const exceuseAndAlternateButtonText = "EXCUSE + ALTERNATE"
    const showCloseButton = true
    const showCancelButton = true
    const spinConfirmButton = this.state.saving
    const disableConfirmOnSpin = true
    const cancelButtonText = "CANCEL"


    return <Modal backdrop="static" centered show={show} onHide={() => this.props.onClose(false)} size={size}>
      <Modal.Header closeButton={showCloseButton}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Row className="form-group">
            <Col>You have selected to excuse {excuseDetails?.FirstName} {excuseDetails?.LastName} from taking a pending {excuseDetails?.Service}. Doing so will remove this event from being tested for the associated pool and will affect the minimum required events to be completed for this selection period. You are required to provide reason for excusal.</Col>
          </Form.Row>
          <Form.Row className="form-group">
            <Col>You have the option to excuse the donor from testing or excusing the donor and selecting an alternate donor from the current selection period.</Col>
          </Form.Row>
          <Form.Row className="form-group">
            <Col>Clicking “Excuse” will mark the scheduling event status as “Excused”, will add the comments to the scheduling notes and will remove the event from the Random Selection Inbox grid. Excused events can be filtered from the Results grid.</Col>
          </Form.Row>
          <Form.Row className="form-group">
            <Col>Clicking “Excuse + Alternate“ will excuse the current donor (same as above) and add an alternate donor to the Inbox grid with a status of “Pending ALT”.  Alternates can be scheduled for testing in the same way as “Pending”.</Col>
          </Form.Row>
          <Form.Row className="form-group">
            <Col>Please note that alternates with be created with same event types as the excused record. (i.e.  If a drug and alcohol were excused, then a drug and alcohol will be created for the alternate donor.)</Col>
          </Form.Row>

          <Form.Row className="form-group">
            <Col md={4} style={{ paddingTop: "2px" }}>
              <Form.Check
                type="radio"
                inline
                id={"ExcuseAndAltrnate"}
                label={exceuseAndAlternateButtonText}
                name={"ExcuseMode"}
                checked={this.state.excuseMode === ExcuseAndAltrnate}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.toggleAlternateExcuseOption(ExcuseAndAltrnate)}
                className="abc-radio abc-radio-primary" />
            </Col>

            <Col md={4} style={{ paddingTop: "2px" }}>
              <Form.Check
                type="radio"
                inline
                id={"ExcuseOnly"}
                label={exceuseButtonText}
                name={"ExcuseMode"}
                checked={this.state.excuseMode === ExcuseOnly}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.toggleAlternateExcuseOption(ExcuseOnly)}
                className="abc-radio abc-radio-primary" />
            </Col>
          </Form.Row>

          <Form.Row className="form-group">
            <Col md={6} style={{ paddingTop: "2px" }}>
              <Form.Control as="select" value={this.state.excuseReasonCode || ""}
                onChange={(e) => this.onAltReasonChange(e.target.value)}
                isInvalid={this.state.excuseReasonCode === ""}
                disabled={false}>
                {AlternateExcuseReasons.map((item: ExcuseReason) => <option value={item.Code} key={item.Code}>{item.Description}</option>)}
              </Form.Control>
            </Col>
          </Form.Row>

          {this.isAltOtherReasonSelectd() &&
            <Form.Row className="form-group required">
              <Form.Label column lg={3} htmlFor="alt_reason_comment">Comment (required)</Form.Label>
            </Form.Row>
          }          
          
          {this.isAltOtherReasonSelectd() &&
            <Form.Row className="form-group required">
              <Col md={6}>
                <Form.Control
                  id="alt_reason_comment"
                  as="textarea"
                  rows={3}
                  value={this.state.excuseComment}
                  onChange={e => this.setState({ excuseComment: e.target.value })} />
              </Col>
            </Form.Row>
          }
        </Form>
      </Modal.Body>
      <Modal.Footer>
        {showCancelButton && <Button variant="secondary" onClick={() => this.props.onClose(false)} className="mr-auto fixed-w5">{cancelButtonText}</Button>}


        <ActionButton variant="primary" onClick={() => this.excuse(true)} disabled={disableExcuseAnAlternateButton} spin={spinConfirmButton} disableOnSpin={disableConfirmOnSpin} className="fixed-w5">{exceuseAndAlternateButtonText}</ActionButton>
        <ActionButton variant="primary" onClick={() => this.excuse(false)} disabled={disableExcuseButton} spin={spinConfirmButton} disableOnSpin={disableConfirmOnSpin} className="fixed-w5">{exceuseButtonText}</ActionButton>
      </Modal.Footer>
    </Modal>
  }
}